module.exports = __webpack_public_path__ + "static/img/Common 2 - Dashboard.8c31d6a.png";